import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import "ol/ol.css";
import { Map, View } from "ol";
import DataService from "../../services/getData";
import MapUtils from "../../utils/mapUtils";
import { Vector as VectorSource } from "ol/source";
import VectorLayer from "ol/layer/Vector";
import Feature from "ol/Feature.js";
import Polygon from "ol/geom/Polygon";

export default function PopupMap({ open, onClose, cityId, selectedGrids }) {

  //console.log("selected Grids= ",selectedGrids);

  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const [loading, setLoading] = useState(false);

  const drawCityPolygonOnMap = (city, map) => {
    const coordinates = city.data.geom;
    var convertedCoordinates = [];
    coordinates.forEach((element) => {
      convertedCoordinates.push([element.x, element.y]);
    });

    const polygonFeature = new Feature({
      type: "Polygon",
      geometry: new Polygon([convertedCoordinates]).transform(
        "EPSG:4326",
        "EPSG:3857"
      ),
      name: city.data.originalCityName,
    });

    polygonFeature.setId(city.data.cityId);

    let source = new VectorSource({
      features: [polygonFeature]
    });

    var layer = new VectorLayer({
      source: source,
      style: MapUtils.Styles.neighborhood
    });
    layer.setZIndex(1);
    map.addLayer(layer);
  };

  const drawCityGridOnMap = (cityGrid, map) => {
    let gridFeature;
    let gridFeatures = [];        
    console.log("Selected Grids:", selectedGrids);
    
    const selectedIds = new Set(
        Array.isArray(selectedGrids) ? selectedGrids.map(grid => grid.gridId) : []
    );

    cityGrid.data.forEach(grid => {        
        gridFeature = MapUtils.getFeaturePolygon(grid.geom);
        if (selectedIds.has(grid.i)) {
            gridFeature.setStyle(MapUtils.Styles.selectedNeighborhood);
        }
        gridFeatures.push(gridFeature)
    })

    const gridLayer = new VectorLayer({
        source: new VectorSource({ features: gridFeatures }),
        //maxZoom: 15,
        minZoom: 8,
        opacity: 0.5
    });    
    gridLayer.setZIndex(2);
    map.addLayer(gridLayer);
    const extent = gridLayer.getSource().getExtent();
    /*console.log("New Fit Grid Layer into view. Extent?", extent);*/
    map.getView().fit(extent, { size: map.getSize(), duration: 600, padding: [5, 5, 5, 5] });
  }

  useEffect(() => {
    if (open) {
      // Espera o Dialog renderizar o Box antes de criar o mapa
      const timer = setTimeout(() => {
        if (mapRef.current) {
          // Limpa mapa anterior
          if (mapInstance.current) {
            mapInstance.current.setTarget(null);
            mapInstance.current = null;
          }

          // Cria novo mapa
          mapInstance.current = new Map({
            target: mapRef.current,
            layers: [MapUtils.GetBaseLayer()],
            view: new View({ center: [0, 0], zoom: 2 }),
          });

          // Ajusta tamanho
          mapInstance.current.updateSize();

          // ✅ Só chama a API depois do mapa estar pronto
          if (cityId) {
            setLoading(true);
            console.log("Fetching city data for cityId:", cityId);
            DataService.GetCity(cityId)
            .then((city) => {
              drawCityPolygonOnMap(city, mapInstance.current); // usa mapInstance.current
              setLoading(false);
            })
            .catch((err) => {
              console.error("Erro na API ao ler a cidade:", err);
              setLoading(false);
            });

          DataService.GetCityGrid(cityId)
            .then(cityGrid => {
              drawCityGridOnMap(cityGrid, mapInstance.current);
            })
              .catch((err) => {
                console.error("Erro na API ao ler a Grid:", err);
              });              
          }
        }
      }, 100); // pequeno delay para garantir que o DOM está pronto

      return () => clearTimeout(timer);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          minHeight: "75vh",
          maxHeight: 'none',          
          margin: 0
        },
      }}      
      sx={{
          '& .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded': {
            maxHeight: 'none'
          },
        }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          textTransform: "uppercase",
          mb: 1,
          mt: 1,
        }}
      >
        Project Location
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="400px"
          >
            <CircularProgress />
            <Box mt={2}>Loading City Map</Box>
          </Box>
        ) : (
          <Box
            ref={mapRef}
            sx={{
              width: "100%",
              height: "60vh", // ✅ altura obrigatória
              borderRadius: "4px",
              overflow: "hidden",
            }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{ mr: 2, mb: 2, py: 1, px: 1, fontWeight: "bold",
            backgroundColor: "#23bced", "&:hover": { backgroundColor: "#23bced" }
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
